
<template>
<div>
  
  <commonHeader>
  </commonHeader>

   
    <mt-navbar  v-model="selected">  
      <mt-tab-item id="1" style="color: white;background-color: rgba(255, 0, 0, 0.61);"><span class="is-selected">追踪/总结/问答</span> </mt-tab-item>  
      <mt-tab-item id="2" style="color: white;background-color: rgba(255, 0, 0, 0.61);"><span class="is-selected">梳理/回顾</span> </mt-tab-item>  
 
    </mt-navbar>  
    <mt-tab-container v-model="selected">  
      
      <mt-tab-container-item  id="1" style="width:100%;margin-bottom:46px;height:cacl(100% - 46px)">  
        <!--热点追踪和精神总结放在了一起-->
        <div style="width:100%;height:100%">
           <!-- <van-row style="height:50px;background-color:red">
              <div style="height:100%;position: absolute;">
                <span>{{day20party}}</span>
              </div>
           </van-row> -->
      
        <van-row>
           <!--热点追踪-->
          <van-col span="12" >
              <ul>
                  <div v-for="item in listrdzz" style="margin-top:10px;text-align:center;margin-left:9px;margin-right:9px;margin-bottom:15px;box-shadow:-2px 0px 2px #C5C8CA,0px -0.5px 0.5px #DFE2E6,2px 0px 2px #C5C8CA,0px 2px 2px #C5C8CA;">
              <p class="box">
                <span style="line-height:35px;font-size:16px; padding-left:10px;">
                  {{ item.title }}
                </span>
              </p>
              <img :src="item.images" alt="" style="width:100%;"  @click="openpop1(item.type)" v-bind:style="{ height: rdzzSize + 'px' }">
              <mt-popup
                v-model="popupVisible1"
                :closeOnClickModal='clickfalse'
                style="width:80%;height:50%; overflow-y:auto;background-color:#FA8072">
                <div style="height:30px" >
                    <span  @click="closepop1(item.type)" style="font-size:20px;float:right;padding-right:15px">x</span>
                </div>
                <div v-if="getitemtype==4" v-for="item4 in rdzzchildren"  >
                           
                             
                             
                                <mt-cell
                                   style="background-color:#FA8072"
                                  :title="item4.desc"
                                  :to="item4.link"
                                  is-link
                                 >
                                  <span style="color: black">{{item4.title}}</span>
                                </mt-cell>
                             
                           
                        </div>
              </mt-popup>
            </div>
            </ul>
          </van-col>
          <!--精神总结,理论之家-->
            <van-col span="12" >
                  <div v-for="itemll in listllzj" style="margin-top:10px;text-align:center;margin-left:9px;margin-right:9px;margin-bottom:15px;box-shadow:-2px 0px 2px #C5C8CA,0px -0.5px 0.5px #DFE2E6,2px 0px 2px #C5C8CA,0px 2px 2px #C5C8CA;">
                      <p class="box">
                        <span style="line-height:35px;font-size:16px; padding-left:10px;">
                          {{ itemll.title }}
                        </span>
                      </p>
                      <img v-lazy.container="itemll.images" alt="" style="width:100%;"  @click="openpop2(itemll.type)" v-bind:style="{ height: llzjSize + 'px' }">
                      <mt-popup
                        v-model="popupVisible2"
                        :closeOnClickModal='clickfalse'
                        style="width:80%;height:70%; overflow-y:auto;background-color:#FA8072">
                        <div style="height:30px" >
                        <span  @click="closepop2(itemll.type)" style="font-size:20px;float:right;padding-right:15px">x</span>
                        </div>
                        <!--左侧介绍-->
                         <!-- <van-col span="12"> 
                          <span>核心精神</span>
                          <div v-if="getitemtype==5" v-for="item5 in llzjchildren"  >
                            <div style=" border: 1px solid rgba(211, 14, 14, 0.666);">
                              <div style="background-color:rgba(189, 9, 51, 0.634);">
                                <span style="width:100%;color:white">{{item5.title}}</span>
                              </div>
                              <div >
                              
                              </div>
                            </div>
                        </div>
                        </van-col> -->
                      <!--右侧故事会-->
                      <van-col span="24">
                        <span style="color:#FFFF33">党的故事</span>
                       <!-- <van-grid :column-num="2">
                         <van-grid-item v-for="value in 6" :key="value" icon="photo-o" :text="文字" />
                       </van-grid> -->
                       <div v-if="getitemtype==5" v-for="itemds in dsgs"  >
                            <div style=" border: 1px solid rgba(211, 14, 14, 0.666);">
                              <div style="background-color:rgba(189, 9, 51, 0.634);">
                                <!-- <span style="width:100%;color:white">{{itemds.title}}</span> -->
                                <mt-cell
                                   style="color:white;background-color:#FA8072  "
                                  :title="itemds.desc"
                                  :to="itemds.link"
                                  is-link
                                 >
                                  <span style="color: white">{{itemds.title}}</span>
                                </mt-cell>
                              </div>
                              <div >
                              
                              </div>
                            </div>
                        </div>
                      </van-col>
                       
                      </mt-popup>
                    </div>
               </van-col>
        </van-row>
        <van-row type="flex" justify="center">
          <van-col span="12">
            <div v-for="item in listnwwd" style="margin-top:10px;text-align:center;margin-left:9px;margin-right:9px;margin-bottom:15px;box-shadow:-2px 0px 2px #C5C8CA,0px -0.5px 0.5px #DFE2E6,2px 0px 2px #C5C8CA,0px 2px 2px #C5C8CA;">
                        <p class="box">
                          <span style="line-height:35px;font-size:16px; padding-left:10px;">
                            {{ item.title }}
                          
                          </span>
                        </p>
                        <div style="width:100%;" v-bind:style="{ height: jszjSize + 'px'} ">
                          <img v-lazy.container="item.images" alt="" style="width:100%;" v-bind:style="{ height: jszjSize + 'px' }">
                            <div style="position: absolute;top:80%; width:50%"   > 
                                <mt-button @click="openvideopan"  size="small" style="color:white;background-color:rgba(189, 9, 51, 0.634);margin: 10px;">
                                      视频
                                </mt-button>
                                <mt-button   size="small" @click="openarticlepan" style="color:white;background-color:rgba(189, 9, 51, 0.634);margin: 10px;">
                                      文章
                                </mt-button>
                             </div>
                          </img> 
                        </div>
                        
            </div>
          </van-col>
           <van-col span="12">
            <div v-for="item in tsss" style="margin-top:10px;text-align:center;margin-left:9px;margin-right:9px;margin-bottom:15px;box-shadow:-2px 0px 2px #C5C8CA,0px -0.5px 0.5px #DFE2E6,2px 0px 2px #C5C8CA,0px 2px 2px #C5C8CA;">
                        <p class="box">
                          <span style="line-height:35px;font-size:16px; padding-left:10px;">
                            {{ item.title }}
                          
                          </span>
                        </p>
                        <div style="width:100%;" v-bind:style="{ height: jszjSize + 'px'} ">
                          <img @click="gotsss()" v-lazy.container="item.images" alt="" style="width:100%;" v-bind:style="{ height: jszjSize + 'px' }">
                      
                          </img> 
                        </div>
                        
            </div>
          </van-col>
          </van-row>
           <!--视频微课面板-->
          <van-popup
            v-model="videopan"
            position="left"
            class="wkpop"
          >
          <van-notify v-model="shownotify" type="warning">
            <van-icon name="bell" style="margin-right: 4px;" />
            <span>{{notifyMessage}}</span>
          </van-notify>
             <div style="height:20px">
                 <van-button style="float:right;
                          height: 20px;
                          text-align: center;
                          margin: 5px; border-radius:10px ; text-align: center;line-height: 20px;"   @click="closevideo" size="mini">x</van-button>
             </div>
               <div style="height:40px">
                   <div style="width:230px;
                  height: 30px;
                  float:left;
                  border: 2px solid pink;
                  margin-left:1%;
        
                 ">
                  <p width="100px;" style="float:left;display: block;
                        width: 25px;
                        height: 20px;
                        text-align: center;
                        background: pink;
                        border-radius: 5px;
                        margin: 5px; text-decoration: none;text-align: center;line-height: 20px; font-size: 13px;">UP: <p>
                  <div style="float:left;
                        height: 30px;
                        text-align: center;
                        text-align: center;line-height: 30px; font-size: 10px;" icon="upgrade"
                        type="primary" 
                        size="mini">快来上传你的微视频吧！</div>
                
                      <van-button style="float:left;
                        height: 20px;
                        text-align: center;
                        margin: 5px; text-align: center;line-height: 20px;"
                        icon="upgrade"
                        type="primary" 
                        size="mini"
                        @click="uploadvideo"
                        >
                        发布
                      </van-button>
                </div>
                <div style="height: 30px;float:right;">
                   <p  style="
                        
                        width: 100px;
                        height: 30px;
                        text-align: center;
                        background: pink;
                        border-radius: 5px;
                        margin-left:5%;
                        margin: 5px; text-decoration: none;text-align: center;line-height: 30px; font-size: 10px;">微课列表</p>
                        
                 </div>
               </div>
                
                  <div v-for="itemv in videolist" style="background:#8080803d;width:94%;height:33%;margin-bottom:15px;margin-top:10px;text-align:center;margin-left:3%;margin-right:3%;margin-bottom:15px;box-shadow:-2px 0px 2px #C5C8CA,0px -0.5px 0.5px #DFE2E6,2px 0px 2px #C5C8CA,0px 2px 2px #C5C8CA;">
                     <div style="text-align: left;height:15">
                         <span style=" background: rgb(233 144 144 / 75%);width:100%;float:left;line-height: 35px;font-size: 16px;height:15%">
                          {{itemv.title}}
                      </span>
                     </div>
                     <div style="height:85%;">
                      <video
                          :src="itemv.videourl"
                           controls
                           width="100%" height="100%"
                           style=" object-fit: cover;
                           object-position: center center;max-height:400px;max-width:500px"
                          :poster="itemv.coverimg"
                      ></video>
                     </div> 
                     
                  </div>
                   <!-- <van-popup v-model="uploadvideoshow" round position="bottom" :style="{ height: '30%' }" >
                          <van-form @submit="onSubmit">
                            <van-field
                              v-model="videotitle"
                              name="视频标题"
                              label="视频标题"
                              placeholder="视频标题"
                              :rules="[{ required: true, message: '请填写视频标题' }]"
                            />
                             <van-uploader
                                upload-icon="https://file.baojunev.com/group1/default/20210527/14/51/6/video_icon@2x.png"
                                accept="video/*"
                                :before-read="beforeRead"
                                :after-read="afterRead"
                                multiple
  	                            :max-count="1"
                              />

                          
                            <div style="margin: 16px;">
                              <van-button round block type="info" native-type="submit">提交</van-button>
                            </div>
                          </van-form>
                  </van-popup> -->
                 
               
          </van-popup>

           <!--原创文章面板-->
        <van-popup
            v-model="articlepan"
            closeable
            close-icon="close"
            position="right"
            class="wkpop"
          >
           <div style="width: 96%;
              height: 40px;
              border: 2px solid pink;
              margin-top: 20px;
              margin-left: 1%;">
              <p width="100px;" style="float:left;display: block;
                    width: 35px;
                    height: 30px;
                    text-align: center;
                   
                    background: pink;
                    border-radius: 5px;
                    margin: 5px; text-decoration: none;text-align: center;line-height: 30px;">UP: <p>
              <div style="float:left;
                   
                    height: 30px;
                    text-align: center;
                    margin: 5px; text-align: center;line-height: 30px;">快来上传原创文章！</div>
              
             
                  <van-button style="float:left;
                    height: 30px;
                    text-align: center;
                    margin: 5px; text-align: center;line-height: 30px;" icon="upgrade" type="primary" size="mini">发布</van-button>
                 <!-- <van-uploader></van-uploader> -->
               <div>
                 
               </div>
          </div>
      </van-popup>
        </div>
       
   
      </mt-tab-container-item>  
      <mt-tab-container-item  id="2"  style="width:100%;margin-bottom:46px" >  
      
        <ul>
         <!-- <li v-for="item in items.smalls"  @click="goIndexTwo(item,1)" style="text-align:left;color:gray;font-size:15px;padding-left:10px;background:white;"><span style="line-height:40px;font-size:14px;">{{item.name}}</span><crossLine></crossLine></li> -->
         <div v-for="item in listthree" style="text-align:center;margin-left:9px;margin-right:9px;margin-bottom:15px;box-shadow:-2px 0px 2px #C5C8CA,0px -0.5px 0.5px #DFE2E6,2px 0px 2px #C5C8CA,0px 2px 2px #C5C8CA;">
           <p class="box">
             <span style="line-height:35px;font-size:16px; padding-left:10px;">
              {{ item.title }}
              <!-- <mt-button type="primary" style="background-color:rgba(128, 128, 128, 0.57);" size="small">{{item.button}}</mt-button> -->
             </span>
             <span style="line-height:35px;font-size:16px;">
              <mt-button @click="openpop(item.type)" type="primary" style="background-color:rgba(128, 128, 128, 0.57);" size="small">{{item.button}}</mt-button>
             </span>
           </p>
           <img v-lazy.container="item.images" alt="" style="width:100%;"  @click="go20(item.link)" v-bind:style="{ height: heightSize + 'px' }">
           <mt-popup
             v-model="popupVisible"
             :closeOnClickModal='clickfalse'
             style="width:80%;height:70%; overflow-y:auto;">
             <div style="height:30px" >
             <span  @click="closepop(item.type)" style="font-size:20px;float:right;padding-right:15px">x</span>
             </div>
             <div v-if="getitemtype==1" v-for="item1 in listbg"  >
                <div style=" border: 1px solid rgba(211, 14, 14, 0.666);">
                  <div style="background-color:rgba(189, 9, 51, 0.634);">
                    <span style="width:100%;color:white">{{item1.title}}</span>
                  </div>
                  <div >
                    <!-- :src="item1.images" -->
                    
                    <img style="width:100%;"  @click="go20(item1.link)" v-lazy.container="item1.images"   >
                  </div>
                </div>
             </div>
              <div v-if="getitemtype==2" v-for="item1 in dsrw">
                 <div style=" border: 1px solid rgba(211, 14, 14, 0.666);">
                  <div style="background-color:rgba(189, 9, 51, 0.634);">
                    <span style="width:100%;color:white">{{item1.title}}</span>
                  </div>
                  <div >
                    <img style="width:100%;" @click="go20(item1.link)" v-lazy.container="item1.images"  >
                  </div>
                </div>
             </div>
             
              <div v-if="getitemtype==3"  v-for="(item1,index) in zghm ">
                 
                 <div style="background-color:rgba(189, 9, 51, 0.634);">
                    <span style="width:100%;color:white">{{item1.title}}</span>
                  </div>
                  <div >
                    <img style="width:100%;" @click="go20(item1.link)" v-lazy.container="item1.images"  >
                  </div>
          
             </div>
              
          </mt-popup>
         </div>
       </ul>



           <div>
               <font style="color:red;text-align:center">
                 <h3>{{message}}</h3>
               </font>
           <table border="2" style="width:90%;margin-left:5%;text-align:center;padding:20px">
                <tr>
                  <th v-for="th in title">{{th}} </th>
                </tr>
                <tr v-for = "people in data">
                  
                  <td>
                    <div @click="go20(people.url)" style="color:blue">
                      {{people.name}}
                    </div> 
                  </td>
                  <td >{{people.time}}</td>
                  <td >{{people.place}}</td>
                </tr>
              </table>
              
        </div>
   

      </mt-tab-container-item>  
      <mt-tab-container-item   id="3">  
       
      </mt-tab-container-item>  
       <mt-tab-container-item  id="4">  
       
      </mt-tab-container-item>  
    </mt-tab-container>  
  </div>  

</div>
  
</template>
 
<script>
import Addr from "./../utils/getAPI";
import openUrl from "./../utils/openUrl";
import commonHeader from "./../components/common-header.vue";
import axios from "axios";

export default {
  name: "party20",
  components: {
    commonHeader,
  },
  data: function () {
    return {
      //二十大倒计时
      data1: null,
      
      heightSize: 400,
      llzjSize: 260,
      jszjSize: 240,
      videopan: false,
      articlepan: false,
      rdzzSize: 260,
      vloading: false,
      clickfalse: false,
      popupVisible: false,
      popupVisible1: false,
      popupVisible2: false,
      popupVisible3: false,
      uploadvideoshow: false,
      videotitle: "",
      shownotify: false,
      notifyMessage: "",
      selected: "1",
      message: "中国共产党全国代表大会",
      title: ["名称", "时间", "地点"],
      data: [
        {
          name: "中共一大",
          time: "1921.07.23-08.03",
          place: "上海",
          url: "https://www.12371.cn/special/lcddh/ddh1/",
        },
        {
          name: "中共二大",
          time: "1922.07.16-07.23",
          place: "上海",
          url: "https://www.12371.cn/special/lcddh/ddh2/",
        },
        {
          name: "中共三大",
          time: "1923.06.12-06.20",
          place: "广州",
          url: "https://www.12371.cn/special/lcddh/ddh3/",
        },
        {
          name: "中共四大",
          time: "1925.01.11-01.22",
          place: "上海",
          url: "https://www.12371.cn/special/lcddh/ddh4/",
        },
        {
          name: "中共五大",
          time: "1927.04.27-05.09",
          place: "武汉",
          url: "https://www.12371.cn/special/lcddh/ddh5/",
        },
        {
          name: "中共六大",
          time: "1928.06.18-07.11",
          place: "莫斯科",
          url: "https://www.12371.cn/special/lcddh/ddh6/",
        },
        {
          name: "中共七大",
          time: "1945.04.23-06.11",
          place: "延安",
          url: "https://www.12371.cn/special/lcddh/ddh7/",
        },
        {
          name: "中共八大",
          time: "1956.09.15-09.27",
          place: "北京",
          url: "https://www.12371.cn/special/lcddh/ddh8/",
        },
        {
          name: "中共九大",
          time: "1969.04.01-04.24",
          place: "北京",
          url: "https://www.12371.cn/special/lcddh/ddh9/",
        },
        {
          name: "中共十大",
          time: "1973.08.24-08.28",
          place: "北京",
          url: "https://www.12371.cn/special/lcddh/ddh10/",
        },
        {
          name: "中共十一大",
          time: "1977.08.12-08.18",
          place: "北京",
          url: "https://www.12371.cn/special/lcddh/ddh11/",
        },
        {
          name: "中共十二大",
          time: "1982.09.01-09.11",
          place: "北京",
          url: "https://www.12371.cn/special/lcddh/ddh12/",
        },
        {
          name: "中共十三大",
          time: "1987.10.25-11.01",
          place: "北京",
          url: "https://www.12371.cn/special/lcddh/ddh13/",
        },
        {
          name: "中共十四大",
          time: "1992.10.12-10.18",
          place: "北京",
          url: "https://www.12371.cn/special/lcddh/ddh14/",
        },
        {
          name: "中共十五大",
          time: "1997.09.12-09.18",
          place: "北京",
          url: "https://www.12371.cn/special/lcddh/ddh15/",
        },
        {
          name: "中共十六大",
          time: "2002.11.08-11.14",
          place: "北京",
          url: "https://www.12371.cn/special/lcddh/ddh16/",
        },
        {
          name: "中共十七大",
          time: "2007.10.15-10.21",
          place: "北京",
          url: "https://www.12371.cn/special/lcddh/ddh17/",
        },
        {
          name: "中共十八大",
          time: "2012.11.08-11.14",
          place: "北京",
          url: "https://www.12371.cn/special/18cpcnc/",
        },
        {
          name: "中共十九大",
          time: "2017.10.18-10.24",
          place: "北京",
          url: "https://www.12371.cn/special/19da/",
        },
      ],
      //三个大分类
      listthree: [],
      getitemtype: null,
      //大分类点开后的小分类
      //1、历届报告
      listbg: [],
      //2、党史人物
      dsrw: [],
      //3、珍贵画面
      zghm: [],
      //热点追踪大分类
      listrdzz: [],
      //总结，理论之家
      listllzj: [],
      listnwwd: [],
      tsss: [],
      llzjchildren: [],
      //党史小故事
      dsgs: [],
      rdzzchildren: [],
      videolist: [],
      startShow: true,
    };
  },

  mounted() {
   
    this.initdata();
   
    setTimeout(() => {
      this.startShow = false;
    }, 2000);
  },
  updated() {},

  methods: {
   
    initdata() {
      axios
        .get(Addr.getGoNewAPIPrefix() + "party/listparty")
        .then((res) => {
          console.log("party20res", res);
          if (res.status == 200) {
            this.listbg = res.data.listbg;
            this.dsgs = res.data.dsgs;
            this.dsrw = res.data.dsrw;
            this.listllzj = res.data.listllzj;
            this.listnwwd = res.data.listnwwd;
            this.listrdzz = res.data.listrdzz;
            this.rdzzchildren = res.data.rdzzchildren;
            this.listthree = res.data.three;
            this.tsss = res.data.tsss;
            this.videolist = res.data.videolist;
            this.zghm = res.data.zghm;
          }
        })
        .catch((err) => {
          console.log(err);
        });

      // axios
      //  .get(Addr.getGoNewAPIPrefix() + "xi/listXiSubject")
      // .then((res) => {
      //     console.log('res',res)
      //   if (res.status == 200) {

      //   }})
    },
    loadTop() {
      // 加载更多数据
      this.$refs.loadmore.onTopLoaded();
    },
    loadBottom() {
      // 加载更多数据
      this.allLoaded = true; // 若数据已全部获取完毕
      this.$refs.loadmore.onBottomLoaded();
    },
    go20(link) {
      // console.log('linklinklinklink',link)
      openUrl.open(link);
    },
    openpop(type) {
      this.getitemtype = parseInt(type);
      console.log("//////", this.getitemtype);
      this.popupVisible = true;
    },
    openpop1(type) {
      this.getitemtype = parseInt(type);
      console.log("//////", this.getitemtype);
      this.popupVisible1 = true;
    },
    openpop2(type) {
      this.getitemtype = parseInt(type);
      console.log("//////", this.getitemtype);
      this.popupVisible2 = true;
    },
    openpop3(type) {
      this.getitemtype = parseInt(type);
      console.log("//////", this.getitemtype);
      this.popupVisible3 = true;
    },
    closepop() {
      this.popupVisible = false;
    },
    closepop1() {
      this.popupVisible1 = false;
    },
    closepop2() {
      this.popupVisible2 = false;
    },
    closepop3() {
      this.popupVisible3 = false;
    },
    openvideopan() {
      this.videopan = true;
    },
    closevideo() {
      this.videopan = false;
    },
    openarticlepan() {
      this.articlepan = true;
    },
    gotsss() {
      this.$router.push("/course");
    },
    //date1和date2是2019-06-18格式 ，计算日期
    getDiffDay(year, month, day, hours) {
      // 计算两个日期之间的差值
      let now = new Date();
      let endDate = new Date(year, month - 1, day, hours);
      let leftTime = endDate.getTime() - now.getTime(); //计算剩余的毫秒数
      if (leftTime <= 0) {
        leftTime = 0;
      }
      let leftsecond = parseInt(leftTime / 1000); //计算剩余的秒数
      let countDay = Math.floor(leftsecond / (60 * 60 * 24));
      return countDay + 1;
    },

    //  getTime(date) {
    //     let y = date.getFullYear() //年
    //     let m = date.getMonth() + 1  //月，月是从0开始的所以+1
    //     let d = date.getDate() //日
    //     m = m < 10 ? "0" + m : m //小于10补0
    //     d = d < 10 ? "0" + d : d //小于10补0
    //     return y + "-" + m + "-" + d; //返回时间形式yyyy-mm-dd
    //   },
    uploadvideo() {
      this.uploadvideoshow = true;
    },
    onSubmit(values) {
      console.log("submit", values);
    },
  },
};
</script>
 
<style scoped>
.is-selected {
  color: white;
  text-align: center;
}
.box {
  width: 100%;
  height: 100%;
  /* 设置元素两端对齐 */
  text-align: justify;
  text-align: justify;
  margin-bottom: 0px;
  height: 35px;
  background-color: white;
}
/* 这里的伪元素一定要加上，不然span元素不能两端对齐 */
.box:after {
  content: "";
  display: inline-block;
  overflow: hidden;
  width: 90%;
}
.box span {
  /* 设置盒子为行内块 */
  display: inline-block;
  /* 设置盒子内元素水平居中 */
  text-align: center;
}
.grind {
  display: grid;
  grid-template-columns: 2fr;
  /* grid-template-rows: 100px 100px 100px; */
  grid-template-rows: 280px;
  grid-gap: 10px;
  padding: 20px;
  margin-left: 3%;
  margin-right: 3%;
  text-align: center;
}

.item {
  position: relative;
  border: 1px solid rgba(211, 14, 14, 0.666);
  height: 280px;
}
img {
  /* width: 100%; */
  height: 100%;
}
.wkpop {
  width: 100%;
  height: calc(100% - 55px);

  margin-top: 15px;
  margin-bottom: 5px;
  border: solid 3px pink;
  border-top-left-radius: 15px;
  overflow-y: auto;
  overflow-x: hidden;
}

</style>


// WEBPACK FOOTER //
// src/module-party20/index.vue